module.exports = __webpack_public_path__ + "img/ch.94cce36b.png";